/** Navigation state store. */

import { create } from 'zustand';

interface NavigationState {
  currentView: string;
  previousView: string | null;
  viewParams: { ticker?: string; author?: string; influencerWindow?: string } | null;
  setCurrentView: (
    view: string,
    params?: { ticker?: string; author?: string; influencerWindow?: string }
  ) => void;
  setPreviousView: (view: string | null) => void;
  getSavedView: () => {
    view: string;
    params?: { ticker?: string; author?: string; influencerWindow?: string };
  } | null;
}

const STORAGE_KEY = 'tkr-scanner-current-view';
const STORAGE_PARAMS_KEY = 'tkr-scanner-view-params';

export const useNavigationStore = create<NavigationState>((set) => ({
  currentView: 'dashboard',
  previousView: null,
  viewParams: null,
  setCurrentView: (view: string, params?: { ticker?: string; author?: string }) => {
    // Save to localStorage
    try {
      localStorage.setItem(STORAGE_KEY, view);
      if (params) {
        localStorage.setItem(STORAGE_PARAMS_KEY, JSON.stringify(params));
      } else {
        localStorage.removeItem(STORAGE_PARAMS_KEY);
      }
    } catch (e) {
      console.warn('Failed to save view to localStorage:', e);
    }
    
    set((state) => ({ 
      currentView: view,
      previousView: state.currentView,
      viewParams: params || null
    }));
  },
  setPreviousView: (view: string | null) => set({ previousView: view }),
  getSavedView: () => {
    try {
      const savedView = localStorage.getItem(STORAGE_KEY);
      if (!savedView) return null;
      
      const savedParams = localStorage.getItem(STORAGE_PARAMS_KEY);
      const params = savedParams ? JSON.parse(savedParams) : undefined;
      
      return { view: savedView, params };
    } catch (e) {
      console.warn('Failed to load saved view from localStorage:', e);
      return null;
    }
  },
}));

